export const cladifyServicePriceTemplate = [
    { 
      id: 'title',
      form: {
        component: 'VTextField',
        bind: {
          placeholder: 'Service price section title'
        }
      },
      display: {
        component: 'h2'
      },
      value: 'Service Price Details'
    },
    { 
      id: 'content',
      display: {
        component: 'DetailedPricingCladifyService',
        bind: {
          itemId: null
        }
      },
      value: ''
    },
    { 
      id: 'desc',
      form: {
        component: 'VTextField',
        bind: {
          placeholder: 'Service Price section description'
        }
      },
      display: {
        component: 'p'
      },
      value: ''
    }
  ]